"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLocalizedSlugs = createLocalizedSlugs;
function createLocalizedSlugs({ slugsByLocale }) {
    const locales = Object.keys(slugsByLocale);
    const PREFIX_SLUGS = Object.fromEntries(Object.entries(slugsByLocale).map(([locale, slugs]) => [locale, slugs.prefixes]));
    const PAGE_SLUGS = Object.fromEntries(Object.entries(slugsByLocale).map(([locale, slugs]) => [locale, slugs.pages]));
    function getPageSlug(locale, pageType) {
        if (!locales.includes(locale)) {
            throw new Error(`Invalid locale: "${locale}". Valid locales are: ${locales.join(", ")}`);
        }
        const localizedSlug = PAGE_SLUGS[locale]?.[pageType];
        if (localizedSlug) {
            return localizedSlug;
        }
        throw new Error(`Page type "${pageType}" not found for locale "${locale}".`);
    }
    function getPrefixSlug(locale, prefixType) {
        if (!locales.includes(locale)) {
            throw new Error(`Invalid locale: "${locale}". Valid locales are: ${locales.join(", ")}`);
        }
        const prefixSlug = PREFIX_SLUGS[locale]?.[prefixType];
        if (prefixSlug) {
            return prefixSlug;
        }
        throw new Error(`Prefix type "${String(prefixType)}" not found for locale "${locale}".`);
    }
    return { PAGE_SLUGS, PREFIX_SLUGS, getPageSlug, getPrefixSlug };
}
